import React, { useState, useEffect } from "react";
import "./detailpage.css";

import hipudrapebanner from "../../images/orthopedic-page-banner.jpg";
import Applicationphoto from "../../images/pdpimage/hipone.jpg";
import ucutcloseup from "../../images/pdpimage/hiptwo.jpg";
import frontdape from "../../images/pdpimage/hipfour.jpg";

const whatsappNumber = "+919619065205";

const ContactBanner = () => (
  <div className="contact-banner">
    <h3>Need guidance choosing the right drape?</h3>
    <p>Our clinical support team is here to assist you.</p>
    <a
      href={`https://wa.me/${whatsappNumber}?text=Hello! I'm interested in bulk procurement of surgical gowns. Please share more details.`}
      className="homepage-btn-primary"
      target="_blank"
      rel="noopener noreferrer"
    >
      Request Bulk Quote
    </a>
    <a
      href={`https://wa.me/${whatsappNumber}?text=Hi! I'd like to receive a brochure of your surgical gown offerings.`}
      className="homepage-btn-primary"
      target="_blank"
      rel="noopener noreferrer"
    >
      Request Brochure
    </a>
  </div>
);

const HipDrape = () => {
  useEffect(() => {
    document.title = "Built by Us, Trusted by Surgeons";
  }, []);

  const thumbnails = [Applicationphoto, frontdape, ucutcloseup];
  const [mainImage, setMainImage] = useState(thumbnails[0]);

  return (
    <>
      <div className="hip-udrape">
        {/* Hero Section */}
        <section
          className="homepage-hero"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${hipudrapebanner})`,
          }}
        >
          <h1 className="homepage-hero-title">Orthopedic Hip U Drape</h1>
          <p className="homepage-hero-subtext">
            Sterile, Reinforced Draping for Hip Arthroplasty & Ortho Procedures
          </p>
          <div className="homepage-hero-buttons">
            <a
              href={`https://wa.me/${whatsappNumber}?text=Hello! I'm interested in bulk procurement of surgical gowns. Please share more details.`}
              className="homepage-btn-outline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Request Quote
            </a>
            <a
              href={`https://wa.me/${whatsappNumber}?text=Hi! I'd like to receive a brochure of your surgical gown offerings.`}
              className="homepage-btn-outline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Request Brochure
            </a>
          </div>
        </section>

        {/* Product Overview with Gallery */}
        <section className="mw-product-details mw-container">
          <div className="mw-gallery">
            <div className="mw-gallery-main">
              <img src={mainImage} alt="Hip U Drape" className="main-gallery-img" />
            </div>
            <div className="mw-gallery-thumbs">
              {thumbnails.map((img, index) => (
                <div
                  key={index}
                  className={`gallery-thumb-img-box ${
                    mainImage === img ? "active-thumb" : ""
                  }`}
                  onClick={() => setMainImage(img)}
                >
                  <img src={img} alt={`Thumbnail ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>

          <div className="mw-product-info">
            <h2 className="homepage-section-title">Product Overview</h2>
            <p>
              Our Orthopedic Hip U Drapes are designed to ensure effective
              coverage and fluid management during complex orthopedic
              procedures. The U-shaped fenestration allows targeted access while
              maintaining a sterile field. Ideal for hip arthroplasty, trauma,
              and joint reconstruction surgeries.
            </p>
            <ul className="mw-list">
              <li>U-shaped opening with fluid collection pouch</li>
              <li>Absorbent and impervious zones</li>
              <li>Reinforced fabric around surgical access area</li>
              <li>Integrated adhesive borders for secure placement</li>
              <li>Available in sterile EO packs</li>
            </ul>

            <h2 className="homepage-section-title">Technical Specifications</h2>
            <table className="mw-specs-table">
              <thead>
                <tr>
                  <th>Parameter</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Fabric</td>
                  <td>SMS/SMMS, 3-layer reinforced zones</td>
                </tr>
                <tr>
                  <td>Size</td>
                  <td>250 x 300 cm / 220 x 320 cm (customizable)</td>
                </tr>
                <tr>
                  <td>Fenestration</td>
                  <td>U-cut reinforced fenestration with fluid pouch</td>
                </tr>
                <tr>
                  <td>Sterility</td>
                  <td>EO Sterilized (single-use)</td>
                </tr>
                <tr>
                  <td>Packaging</td>
                  <td>1 pc per pack; 20 packs/carton</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Compliance */}
        <section className="mw-compliance">
          <h2 className="homepage-section-title">Certifications & Standards</h2>
          <ul className="mw-cert-list">
            <li>
              <span className="checkmark">✅</span>
              <span>ISO 13485:2016</span>
            </li>
            <li>
              <span className="checkmark">✅</span>
              <span>EN 13795 High Performance</span>
            </li>
            <li>
              <span className="checkmark">✅</span>
              <span>MDR Compliant</span>
            </li>
          </ul>
        </section>

        {/* Footer CTA */}
        <ContactBanner />
      </div>
    </>
  );
};

export default HipDrape;
